// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostBody-moduleNewsboardPostBody__G0DVq";
export { _1 as "NewsboardPostBody" }
